import { createBrowserRouter } from "react-router-dom";
import MainLayout from "./layouts/MainLayout";
import PublicLayout from "./components/PublicLayout/PublicLayout";
import Homepage from "./pages/Homepage";
import Resources from "./pages/Resources";
import Blog from "./pages/Blog";
import Login from "./pages/Login";
import RepeatAudio from "./components/RepeatAudio/RepeatAudio";
import VocabularyDaily from "./pages/VocabularyDaily";
import VocabularyJapanese from "./pages/VocabularyJapanese";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";

export const router = createBrowserRouter([
    {
        path: "/login",
        element: (
            <ProtectedRoute requireAuth={false}>
                <Login />
            </ProtectedRoute>
        ),
    },
    // Public Homepage - accessible without login
    {
        path: "/",
        element: <PublicLayout />,
        children: [
            {
                index: true,
                element: <Homepage />,
            },
        ],
    },
    // Protected Routes - require authentication
    {
        path: "/resources",
        element: (
            <ProtectedRoute requireAuth={true}>
                <MainLayout/>
            </ProtectedRoute>
        ),
        children: [
            {
                index: true,
                element: <Resources/>,
            }
        ]
    },
    {
        path: "/vocabulary-daily",
        element: (
            <ProtectedRoute requireAuth={true}>
                <MainLayout/>
            </ProtectedRoute>
        ),
        children: [
            {
                index: true,
                element: <VocabularyDaily/>,
            }
        ]
    },
    {
        path: "/vocabulary-japanese",
        element: (
            <ProtectedRoute requireAuth={true}>
                <MainLayout/>
            </ProtectedRoute>
        ),
        children: [
            {
                index: true,
                element: <VocabularyJapanese/>,
            }
        ]
    },
    {
        path: "/blogs",
        element: (
            <ProtectedRoute requireAuth={true}>
                <MainLayout/>
            </ProtectedRoute>
        ),
        children: [
            {
                index: true,
                element: <Blog/>,
            }
        ]
    },
    {
        path: "/repeat-audio",
        element: (
            <ProtectedRoute requireAuth={true}>
                <MainLayout/>
            </ProtectedRoute>
        ),
        children: [
            {
                index: true,
                element: <RepeatAudio/>,
            }
        ]
    },
    {
        path: "/jptype",
        element: (
            <ProtectedRoute requireAuth={true}>
                <MainLayout/>
            </ProtectedRoute>
        ),
        children: [
            {
                index: true,
                element: <div>AI Weight</div>,
            }
        ]
    },
]);
